export const typography = {
  fontSize: 16,
  fontWeight: {
    bold: 600,
    medium: 500,
    regular: 400,
  },
};
